import type {
	BreakpointCustomizable,
	ButtonPureAlignLabel,
	PButtonPureProps,
	PLinkPureProps,
} from "@porsche-design-system/components-react"
import { PButtonPure, PLinkPure } from "@porsche-design-system/components-react"

import type { ActionItem as ActionItemAPI } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import type { ReactNode } from "react"
import { Link } from "react-router"
import { Tooltip } from "../tooltip/Tooltip"

export interface ActionItemProps {
	hideLabel?: PButtonPureProps["hideLabel"]
	icon?: PButtonPureProps["icon"]
	isLoading?: boolean
	onClick?: () => void
	route?: string
	view: ActionItemAPI | { disabledHint?: ReactNode; label?: string }
}

export const ActionItem = (props: ActionItemProps) => {
	const { hideLabel, icon, isLoading, onClick, route, view, ...rest } = props

	const isDisabled = useMemo(() => !!view.disabledHint, [view.disabledHint])

	const alignLabel: BreakpointCustomizable<ButtonPureAlignLabel> = "start"
	const type: PButtonPureProps["type"] = "button"

	const buttonLinkProps: PLinkPureProps & PButtonPureProps = {
		...rest, // contains data-testid
		alignLabel,
		disabled: isDisabled,
		hideLabel,
		icon,
		type,
	}

	return (
		<Tooltip content={view.disabledHint}>
			{route ? (
				!isDisabled ? (
					<PLinkPure {...buttonLinkProps} {...rest}>
						<Link to={route}>{view.label}</Link>
					</PLinkPure>
				) : (
					// link can't be disabled, so we use a button
					<PButtonPure {...buttonLinkProps}>{view.label}</PButtonPure>
				)
			) : (
				<PButtonPure {...buttonLinkProps} loading={isLoading} onClick={onClick}>
					{view.label}
				</PButtonPure>
			)}
		</Tooltip>
	)
}
